import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col, Input, Button} from 'react-bootstrap'
import cx from 'classnames'
import ButtonToggle from '../../core/components/ButtonToggle'
import matcher from '../../core/matcher'
import Picker from '../../core/components/Picker'
import Icon from '../../core/components/Icon'
import IconCateg from '../../core/components/IconCateg'
import {queryOpeningTicketPurposeRef} from '../actions'
import {OpeningTicketPurposeRef} from '../models'
import i18n from '../i18n'
import style from './OpeningTicketPurposePicker.less'
import QualificationCriteriaAnswers from '../../ticket/components/QualificationCriteriaAnswers'

function openingTicketPurposeFilter(categories, tags) {
    return (openingTicketPurpose) => {
        if (!openingTicketPurpose.enabled) return false

        for (var i = 0 ; i < tags.length ; i++) {
            if (!openingTicketPurpose.tags.find((t) => t.uid == tags[i].uid)) return false
        }
        for (var i = 0 ; i < categories.length ; i++) {
            if (openingTicketPurpose.categories.find((c) => c.uid == categories[i].uid)) return true
        }
        return (categories.length == 0) && true || false
    }
}

function tagAggregator(reference, tags) {
    return (result, openingTicketPurpose) => {
        openingTicketPurpose.tags.forEach((tag) => {
            var aggrega = result.find((a) => a.tag.uid == tag.uid)
            if (aggrega) {
                aggrega.count++
                return
            }

            var tagz = tags.find((t) => t.uid == tag.uid)
            if (tagz) {
                return
            }

            tagz = reference.tags.find((t) => t.uid == tag.uid)
            if (!tagz) {
                console && console.warn('tag "' + tag.uid + '" doesn\'t exist in referentiel')
                return
            }

            aggrega = {
                tag: tagz,
                count: 1
            }
            result.push(aggrega)
        })
        return result
    }
}

function categoryAggregator(reference, parentCategory) {
    return (result, openingTicketPurpose) => {
        openingTicketPurpose.categories.forEach((category) => {
            const categoryz = reference.categories.find((c) => c.uid == category.uid)
            if (!categoryz) {
                console && console.warn('category "' + category.uid + '" doesn\'t exist in referentiel')
                return
            }

            const categoryPath = OpeningTicketPurposeRef.expendParentCategories(reference, categoryz)
            const ancestorCategory = OpeningTicketPurposeRef.truncCategoryPath(categoryPath, parentCategory)[0]

            if (!ancestorCategory) {
                return
            }

            var aggrega = result.find((a) => a.category.uid == ancestorCategory.uid)
            if (aggrega) {
                return
            }

            aggrega = {
                category: ancestorCategory
            }

            result.push(aggrega)
        })
        return result
    }
}

function defaultTagAggregation(reference, tags) {
    const defaultTag = reference.default.tag

    if (!tags.find((t) => t.uid == defaultTag.uid)) {
        return [{
            tag: defaultTag,
            count: 1000
        }]
    }
    return []
}

function defaultTagCriteria(reference, tags) {
    const defaultTag = reference.default.tag

    if (tags.find((t) => t.uid == defaultTag.uid)) {
        return {
            tags: [defaultTag],
            category: null
        }
    }
    return {tags}
}

function categoryOrTagMatcher(categoryOrTags) {
    return matcher({
        source: categoryOrTags,
        identify: (cot) => cot.label
    })
}

const deepGet = (obj, path) => {
    if (!obj)
        return undefined
    const first = path[0]
    if (path.length === 1)
        return obj[first]
    return deepGet(obj[first],path.slice(1))
}

class OpeningTicketPurposePicker extends Component {
    static propTypes = {
        company: PropTypes.any.isRequired
    }

    constructor(props) {
        super(props)

        this.state = {
            criteria: {
                tags: []
            },
            filteredOpeningTicketPurposes: [],
            categoryMatches: [],
            tagMatches: []
        }
    }

    componentWillMount() {
        const {dispatch, company} = this.props
        dispatch(queryOpeningTicketPurposeRef(company.uid))
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.company != this.props.company) {
            const {dispatch, company} = nextProps
            dispatch(queryOpeningTicketPurposeRef(company.uid))
        }

        if (this.props.reference != nextProps.reference) {
            const {reference} = nextProps
            const categoryUid = deepGet(nextProps , ['cmd','otp','criteria', 'categoryUid']) || { uid: undefined}
            const resolveCategory = (reference.categories || []).find(c => c.uid === categoryUid)

            const {criteria} = this.state

            if (!criteria.category && resolveCategory) {
                this.setState({criteria: {...criteria, category: resolveCategory}})
            }

            const openingTicketPurposes = [...reference.openingTicketPurposes, reference.default.openingTicketPurpose]
            const filteredOpeningTicketPurposes = openingTicketPurposes.filter(openingTicketPurposeFilter(OpeningTicketPurposeRef.expendChildrenCategories(reference, criteria.category || resolveCategory), criteria.tags))
            const tagAggregation = filteredOpeningTicketPurposes.reduce(tagAggregator(reference, criteria.tags), defaultTagAggregation(reference, criteria.tags))
            const filteredTags = tagAggregation.sort((a, b) => b.count - a.count).map((a) => a.tag)
            const filteredCategories = filteredOpeningTicketPurposes.reduce(categoryAggregator(reference, criteria.category || resolveCategory), []).map((a) => a.category)
            const categorySource = categoryOrTagMatcher(filteredCategories)
            const tagSource = categoryOrTagMatcher(filteredTags)
            const query = null

            categorySource(query, (categoryMatches) => {
                tagSource(query, (tagMatches) => {
                    this.setState({filteredOpeningTicketPurposes, categorySource, tagSource, query, categoryMatches, tagMatches})
                })
            })
        }
    }

    _filter(criteriaUpdate) {
        const {reference} = this.props
        const {criteria} = this.state

        const nextCriteria = {...criteria, ...criteriaUpdate}

        const openingTicketPurposes = [...reference.openingTicketPurposes, reference.default.openingTicketPurpose]
        const filteredOpeningTicketPurposes = openingTicketPurposes.filter(openingTicketPurposeFilter(OpeningTicketPurposeRef.expendChildrenCategories(reference, nextCriteria.category), nextCriteria.tags))
        const tagAggregation = filteredOpeningTicketPurposes.reduce(tagAggregator(reference, nextCriteria.tags), defaultTagAggregation(reference, nextCriteria.tags))
        const filteredTags = tagAggregation.sort((a, b) => b.count - a.count).map((a) => a.tag)
        const filteredCategories = filteredOpeningTicketPurposes.reduce(categoryAggregator(reference, nextCriteria.category), []).map((a) => a.category)
        const categorySource = categoryOrTagMatcher(filteredCategories)
        const tagSource = categoryOrTagMatcher(filteredTags)
        const query = null

        categorySource(query, (categoryMatches) => {
            tagSource(query, (tagMatches) => {
                this.setState({filteredOpeningTicketPurposes, categorySource, tagSource, query, categoryMatches, tagMatches, criteria: nextCriteria})
            })
        })
    }

    _match(event) {
        const {categorySource, tagSource} = this.state
        const query = event.target.value || null

        categorySource(query, (categoryMatches) => {
            tagSource(query, (tagMatches) => {
                this.setState({query, categoryMatches, tagMatches})
            })
        })
    }

    _clear(event) {
        const {categorySource, tagSource} = this.state
        const query = null

        event.preventDefault()

        categorySource(query, (categoryMatches) => {
            tagSource(query, (tagMatches) => {
                this.setState({query, categoryMatches, tagMatches})
            })
        })
    }

    render() {
        const {children, dispatch, reference, company, value, qualification, multi, split, onQualificationChange, ...others} = this.props
        const {filteredOpeningTicketPurposes, query, categoryMatches, tagMatches, criteria} = this.state

        const displayOpeningTicketPurpose = (openingTicketPurpose, mode) => {
            if (mode == 'Picked') {
                return (
                    <h4>{openingTicketPurpose.label}</h4>
                )
            }
            return openingTicketPurpose.label
        }

        const displayCategory = (category, active, path) => {
            return (
                <div className={style.category}>
                    <IconCateg iconId={category.iconId} exponent={active && 'X'}/>
                    <label>{category.label}</label>
                    {path && (
                        <small>></small>
                    )}
                </div>
            )
        }

        const displayTag = (tag, active) => {
            return (
                <div className={style.tag}>
                    <IconCateg iconId={tag.iconId} exponent={active && 'X'}/>
                    <label>{tag.label}</label>
                </div>
            )
        }

        const inputButton = query && (
            <Button
                onClick={(e) => this._clear(e)}>
                <Icon icon='cross' size='xs' />
            </Button>
        )

        const inputAddon = !query && (
            <Icon icon='search' size='xs' />
        )

        const categoryPathField = () => {
            const value = OpeningTicketPurposeRef.expendParentCategories(reference, criteria.category)

            const onChange = (categories) => {
                const category = OpeningTicketPurposeRef.getLeafCategory(categories)
                this._filter({category})
            }

            return {value, onChange}
        }

        return (
            <Row>
                <Col sm={split && 4 || 6}>
                    {(!!value && children) || (
                        <div className={style.side}>
                            <Input
                                type='text'
                                buttonAfter={inputButton}
                                addonAfter={inputAddon}
                                placeholder={i18n.searchOpeningTicketPurpose}
                                disabled={!multi && !!value}
                                value={query}
                                onChange={(e) => this._match(e)} />
                            <div className={style.categoryTagSection}>
                                <ButtonToggle
                                    identify={(c) => c.uid}
                                    value={criteria.category}
                                    onChange={(category) => this._filter({category})}>
                                    <ul className={cx(style.categoryTagGroup, style.categoryGroup)}>
                                        {categoryMatches.map((category) => (
                                            <li key={category.uid}>
                                                <Button
                                                    bsStyle='link'
                                                    value={category}
                                                    disabled={!multi && !!value}>
                                                    {displayCategory(category)}
                                                </Button>
                                            </li>
                                        ))}
                                    </ul>
                                </ButtonToggle>
                                <ButtonToggle multi
                                    identify={(t) => t.uid}
                                    value={criteria.tags}
                                    onChange={(ts) => this._filter(defaultTagCriteria(reference, ts))}>
                                    <ul className={style.categoryTagGroup}>
                                        {tagMatches.map((tag) => (
                                            <li key={tag.uid}>
                                                <Button
                                                    bsStyle='link'
                                                    value={tag}
                                                    disabled={!multi && !!value}>
                                                    {displayTag(tag)}
                                                </Button>
                                            </li>
                                        ))}
                                    </ul>
                                </ButtonToggle>
                            </div>
                        </div>
                    )}
                </Col>
                <Col sm={split && 8 || 6}>
                    <div className={style.main}>
                        {(!!value && !!children) || (
                            <div className={style.categoryTagSection}>
                                <ButtonToggle multi
                                    identify={(c) => c.uid}
                                    {...categoryPathField()}>
                                    <ul className={cx(style.categoryTagGroup, style.categoryGroup)}>
                                        {OpeningTicketPurposeRef.expendParentCategories(reference, criteria.category).map((category, index, array) => (
                                            <li key={category.uid}>
                                                <Button
                                                    bsStyle='link'
                                                    value={category}
                                                    disabled={(!multi && !!value) || (index < array.length - 1)}>
                                                    {displayCategory(category, index == array.length - 1, true)}
                                                </Button>
                                            </li>
                                        ))}
                                    </ul>
                                </ButtonToggle>
                                <ButtonToggle multi
                                    identify={(t) => t.uid}
                                    value={criteria.tags}
                                    onChange={(tags) => this._filter({tags})}>
                                    <ul className={style.categoryTagGroup}>
                                        {criteria.tags.map((tag) => (
                                            <li key={tag.uid}>
                                                <Button
                                                    bsStyle='link'
                                                    value={tag}
                                                    disabled={!multi && !!value}>
                                                    {displayTag(tag, true)}
                                                </Button>
                                            </li>
                                        ))}
                                    </ul>
                                </ButtonToggle>
                            </div>
                        )}
                        <Picker
                            multi={multi}
                            split={split}
                            source={filteredOpeningTicketPurposes}
                            identify={(otp) => otp.uid}
                            display={displayOpeningTicketPurpose}
                            value={value}
                            {...others} />
                        {!!value && onQualificationChange && <div>
                            <QualificationCriteriaAnswers clientCompany={company && company.uid}
                                                          otp={value && value.uid}
                                                          qualification={qualification}
                                                          onChange={(qualification) => onQualificationChange({qualification})}/>
                        </div>}
                    </div>
                </Col>
            </Row>
        )
    }
}

OpeningTicketPurposePicker = connect((state) => ({
    reference: state.reference.openingTicketPurposeRef,
    cmd: state.ticket.openTicketCmd
}))(OpeningTicketPurposePicker)

export default OpeningTicketPurposePicker


// WEBPACK FOOTER //
// ./lib/reference/components/OpeningTicketPurposePicker.js